exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video[data-v-284019e0]{padding:20px;background:#fff}.video h3[data-v-284019e0]{margin-bottom:20px;color:#1a1a1a;font-weight:500}.video iframe[data-v-284019e0]{width:100%;height:100px;border-radius:8px}.video h1[data-v-284019e0]{font-weight:500;margin-bottom:20px}@media only screen and (min-width:1024px){.course .video iframe[data-v-284019e0]{height:calc(100% - 80px)}}@media only screen and (max-width:768px){.course .video iframe[data-v-284019e0]{height:250px}}", ""]);

// exports
